import React, { useState } from 'react'
import { Facet } from '../../search-spring/types/types'
import MobileFilterItem from './MobileFilterItem'

type Props = {
  filter: Facet
  index: number
}

const MobileFilter = ({filter, index}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggleAccordion = (): void => {
    setIsOpen(!isOpen)
  }
  return (
    <div key={index} className={`flex flex-col px-5 py-2.5 relative ${isOpen ? 'pb-SM' : null}`}>
      <div className="flex justify-between" onClick={toggleAccordion}>
        <h2 className="font-bstSpyre uppercase text-sm">{filter.label}</h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none"
          className={`transform transition-transform ${isOpen ? 'rotate-90' : ''}`}
        >
          <path d="M2.91675 1.4165L6.92717 5.99984L2.91675 10.5832" stroke="black" strokeLinecap="round"/>
        </svg>
      </div>
      <div className={`transition-max-height duration-200 ${isOpen ? 'max-h-screen' : 'overflow-hidden max-h-0'}`}>
        <div className="flex flex-col mt-2XS">
        {filter.values.map((value, subIndex: number) => (
          <MobileFilterItem key={subIndex} filterValue={value} filter={filter} />
        ))}
        </div>
      </div>
    </div>
  )
}

export default MobileFilter